import { BiEditAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import AppRoutePath from "../../../router/AppRoutePath";
import { FaTrashAlt } from "react-icons/fa";
import { RiDeleteBin5Fill } from "react-icons/ri";

export const descriptionNotification = [
  "Jika hari pengiriman notifikasi diisi menggunakan tanda minus (-) di depan angka, maka notifikasi akan dikirim sebelum tanggal jatuh tempo. Contoh: -3, maka notifikasi akan dikirim H-3 sebelum jatuh tempo.",
  "Jika hari pengiriman notifikasi diisi tanpa tanda apapun di depan angka, maka notifikasi akan dikirim setelah tanggal jatuh tempo. Contoh: 1, maka notifikasi akan dikirim H+1 setelah jatuh tempo.",
  "Jika hari pengiriman notifikasi diisi angka nol (0), maka notifikasi akan tepat pada  tanggal jatuh tempo.",
  "Anda dapat menggunakan variabel yang dibutuhkan ke dalam skrip notifikasi dengan cara klik variabel yang ingin anda masukkan.",
];

export const initForm = {
  title: "",
  days: "",
  desc: "",
  unit:'day'
};

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
};

export const renderColumns = (handleDelete) => {
  return [
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Notifikasi",
    },
    {
      dataIndex: "days",
      key: "days",
      title: "Hari Pengiriman Notifikasi",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="col-1 d-flex justify-content-center flex-row">
          <div className="mr-2">
            <CanAccess
              role={AuthorizationList.update_notification_group}
              yes={
                <Link
                  to={{
                    pathname: AppRoutePath.EDIT_NOTIFICATION.replace(
                      ":id",
                      record.id
                    ),
                  }}
                >
                  <BiEditAlt
                    style={{
                      fontSize: 24,
                      color: "#F5CB58",
                      cursor: "pointer",
                    }}
                  />
                </Link>
              }
            />
          </div>

          <CanAccess
            role={AuthorizationList.delete_notification_group}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};

export const initCondition = [
  { label: "Setelah Tagihan Lunas", value: "after_paid_off" },
  { label: "Jika Tagihan Belum Lunas", value: "before_paid_off" },
];
